import { foundations } from './foundations';
import { advanced } from './advanced';
import { amrChapters, amrCommit } from './amr';
import { isAmr } from '../course';
export const polycfdChapters = [...foundations, ...advanced].sort((a, b) => a.number - b.number);
export const chapters = isAmr ? amrChapters : polycfdChapters;
export { parts } from './types';
export const sourceCommit = isAmr ? amrCommit : 'b7f5b9ba6f52355d9b196b586e4a6c8719d8feea';
export const sourceDate = isAmr ? 'September 28, 2026' : 'September 27, 2026';
export const sourceUrl = (path: string) => isAmr ? '/sources/polycfdamr-review.md' : `https://github.com/hankbeasley/polycfd/blob/${sourceCommit}/${path.replace(/^\/+/, '')}`;
